var React = require('react');

function CommonPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"common-path","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M1442.2046301 23.23604022s-534.96458188-110-766.43486523 206c-231.47028334 316-486.28628196 455.5-671.06513476 316"}));
}

CommonPath.defaultProps = {"viewBox":"0 0 1446.909 603.976"};

module.exports = CommonPath;

CommonPath.default = CommonPath;
